import { Injectable, inject } from '@angular/core';

import { LOGIN_RESPONSE_HANDLER_HOOK, LoginResponseHandlerService, OnFeatureInit } from '@frontend/vanilla/core';

@Injectable()
export class LastSessionInfoBootstrapService implements OnFeatureInit {
    private loginResponseHandlerService = inject(LoginResponseHandlerService);
    private loginResponseHandlerHooks = inject(LOGIN_RESPONSE_HANDLER_HOOK);

    onFeatureInit() {
        this.loginResponseHandlerService.registerHooks(this.loginResponseHandlerHooks);
    }
}
